/**
 * Layout component contains header and footer
 *
 * @package gatsby-wordpress-theme
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { navigate } from 'gatsby';

import { I18nextProvider } from "react-i18next"
import i18n from "§/i18n"

import "§/src/fonts/fonts.css"
import "§/src/sass/theme.scss"
import "§/src/sass/layout/layout.scss"

import { scrollToTop } from "§/src/utils/scrollToTop";


// import DevGrid from "../_dev/grid";
import Header from "../header"
import Footer from "../footer"

const Layout = ({ children, data, className, breadcrumbs, lang, langReplace }) => {
  useEffect(() => {

    scrollToTop()

    // Close modals when go back to previous page
    const modalBackdrop = document.querySelector('.modal-backdrop')
    modalBackdrop && modalBackdrop.remove()


    // Adjust scroll position to avoid header overlap when a URL with a hash is called
    const adjustScrollPosition = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          const header = document.querySelector('#main-nav');
          const headerHeight = header.offsetHeight;
          const offsetTop = element.getBoundingClientRect().top;
          window.scrollTo(0, offsetTop - headerHeight);
        }
      }
    }
    // Call the adjustScrollPosition function
    setTimeout(adjustScrollPosition, 500);

  }, [])


  return (
    <I18nextProvider i18n={i18n}>
      <Header lang={lang} langReplace={langReplace} className={className} data={data} breadcrumbs={breadcrumbs} />
      <main className="main-container container-max">{children}</main>
      <Footer lang={lang} langReplace={langReplace} data={data} />
    </I18nextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
